import React from "react";
import "./CopyToClipboard.css";
import useRagApi from "../../hooks/useRagApi";

const CopyToClipboard = ({ text, initialContactId, qid, submitIsCopied }) => {

  const copyToClipBoard = (event) => {
    event.preventDefault();
    window.navigator.clipboard.writeText(text);
  };

  return (
    <i
      className="fa-regular fa-copy copy-icon"
      onClick={(e) => {
        copyToClipBoard(e);
        submitIsCopied();
      }}
    ></i>
  );
};

export default CopyToClipboard;
